import React, { Component } from "react";
import StripeBtn from "./StripeBtnNew";
import Redemption from "./Redemption";
import RedemptionPage from "./RedemptionPage";
import { Elements } from "@stripe/react-stripe-js";
import { stripePromise } from "../../variables/StripeConfig";
import { deploymentEnvironment, customLog } from "../../variables/Variables";
import { fire, auth } from "../../firebase/index";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import Loading from "../../components/Loading/Loading";
import { ClipLoader } from "react-spinners";
import LocalizedStrings from "react-localization";
//? import chatbot
// import Chatbot from "../../views/Chatbot/Chatbot";
let localizationStrings = new LocalizedStrings({
  en: {
    subscriptionTitle: "Subscription Plans",
    redemptionTitle: "Redemption Menu",
    selectTitle: "- Please Select Your lock Type -",
    subscriptionTitle2: "eGeeTouch IAM Subscription Plans",
    subMessage_1: "Start ",
    subMessage_2: "free",
    subMessage_3: ".",
    subMessage_4: " No credit card required.",
    mainHeader: "eGeeTouch Package",
  },
  ja: {
    subscriptionTitle: "サブスクリプションプラン",
    redemptionTitle: "プロダクトコードでの申込み（IAMカード）",
    selectTitle: "ロックを選択してください",
    subscriptionTitle2:
      "eGeeTouch IAM サブスクリプションプラン",
    subMessage_1: "※お申込み後14日間は、完全無料でご利用いただけます。",
    subMessage_2: "",
    subMessage_3: "",
    subMessage_4: "",
    mainHeader: "eGeeTouch パッケージ",
  },
  es: {
    subscriptionTitle: "Planes de Suscripción",
    redemptionTitle: "Menú de Canje",
    selectTitle: "- Por favor seleccione su tipo de candado -",
    subscriptionTitle2: "Plan de Suscripción eGeeTouch IAM",
    subMessage_1: "Comienza ",
    subMessage_2: "gratis",
    subMessage_3: ".",
    subMessage_4: " No se requiere tarjeta de crédito.",
    mainHeader: "Paquete eGeeTouch",
  },
});

const override = {
  display: "block",
  margin: "0 auto",
};

const planTitleStyle = {
  fontSize: "2.5em",
  fontWeight: "bold",
  marginBottom: "10px",
  textAlign: "center",
};

export default class Plans extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isActiveCodeExist: false,
      isPaymentValid: false,
      isAdmin: false,
      isSuperAdmin: false,
      loading: true,
      isPlanButtonClicked: false,
      planButtonState: "",
      specialTrialMode: false,
      existingAccount: false,
    };
    this.handleSessionPlanRouteNewUser = this.handleSessionPlanRouteNewUser.bind(
      this
    );
  }

  componentWillMount() {
    //! LANGUAGE SETTING
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid) // get uid from auth person object
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            currentLanguage: snapshot.val(),
          });
        });

      fire
        .database()
        .ref("groupAccounts")
        .once("value")
        .then((snapshot) => {
          snapshot.forEach((user) => {
            let userId = user.key;

            fire
              .database()
              .ref("groupAccounts")
              .child(userId)
              .child("members")
              .once("value")
              .then((childSnapshot) => {
                childSnapshot.forEach((member) => {
                  let memberVal = member.val();
                  if (memberVal.memberEmail === auth.currentUser.email) {
                    if (memberVal.isSuperAdmin === true) {
                      this.setState({
                        existingSuperAdminStatus: true,
                        existingAccount: true,
                        specialTrialMode: user.val().payment.specialTrialMode,
                      });
                    } else {
                      this.setState({ existingAccount: true });
                    }
                  }
                });
              });
          });
        });

      // fire
      //   .database()
      //   .ref("groupAccounts")
      //   .child(auth.currentUser.uid)
      //   .child("payments")
      //   .once("value")
      //   .then(snapshot => {
      //     if(snapshot.exists()) {
      //       this.setState({
      //         specialTrialMode: snapshot.val().specialTrialMode,
      //       })
      //     }
      //   })

      const newUserPlanRoute = sessionStorage.getItem("planButtonClicked");

      if (newUserPlanRoute !== null && newUserPlanRoute !== undefined) {
        this.setState({
          isPlanButtonClicked: true,
          planButtonState: newUserPlanRoute,
        });
      }
    }

    const groupAccountsDB = fire.database().ref("groupAccounts");

    groupAccountsDB
      .once("value")
      .then(async (snapshot) => {
        if (snapshot.exists()) {
          await snapshot.forEach((eachSuperAdmin) => {
            const superAdminDetails = eachSuperAdmin.val();
            // const superAdminId = eachSuperAdmin.key;
            const members = superAdminDetails.members;

            for (const eachMembers in members) {
              const memberDetails = members[eachMembers];
              if (memberDetails.memberEmail === auth.currentUser.email) {
                const paymentDetails = superAdminDetails.payment.isPaymentValid;
                this.setState({
                  isAdmin: memberDetails.isAdmin,
                  isSuperAdmin: memberDetails.isSuperAdmin,
                  isPaymentValid: paymentDetails,
                });
              }
            }
          });
        }
      })
      .then(async () => {
        await groupAccountsDB
          .child(auth.currentUser.uid)
          .child("payment")
          .once("value")
          .then(async (snapshot) => {
            if (snapshot.exists()) {
              // console.log(snapshot.val().currentRedemptionActiveCode);
              if (
                snapshot.val().currentRedemptionActiveCode !== "" &&
                snapshot.val().currentRedemptionActiveCode !== null &&
                snapshot.val().currentRedemptionActiveCode !== undefined
              ) {
                await this.setState({
                  isActiveCodeExist: true,
                });
              }
            }
          });
      })
      .then(() => {
        this.setState({
          loading: false,
        });
      });
  }

  handleSessionPlanRouteNewUser() {
    const newUserRoute = sessionStorage.getItem("planButtonClicked");
  }

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    //! LANGUAGE SETTING
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }

    customLog(deploymentEnvironment ? "Live Environment @ Plans" : "Test Environment @ Plans");

    if (!this.state.loading) {
      return (
        //! Check the key and cloud function before uploading  .for test and live have different keys and cloud function
        <div style={{ width: "95%", marginLeft: "auto", marginRight: "auto" }}>
          <div className="header">
            <h2>{localizationStrings.mainHeader}</h2>
          </div>

          {this.state.isPaymentValid === true ? (
            this.state.specialTrialMode === true ? (
              <Tabs forceRenderTabPanel defaultIndex={0}>
                <TabList>
                  <Tab>{localizationStrings.subscriptionTitle}</Tab>
                  <Tab>{localizationStrings.redemptionTitle}</Tab>
                </TabList>
                <TabPanel>
                  <div className="example">
                    <div id="egeeTouchPlans" style={planTitleStyle}>
                      {localizationStrings.subscriptionTitle2}
                    </div>
                    <h3
                      style={{
                        display: this.state.existingAccount ? "none" : "",
                        textAlign: "center",
                        marginBottom: "30px",
                      }}
                    >
                      {localizationStrings.subMessage_1}
                      <span style={{ color: "#0e78db" }}>
                        {localizationStrings.subMessage_2}
                      </span>
                      {localizationStrings.subMessage_3}
                      <span style={{ fontSize: "20px" }}>
                        {localizationStrings.subMessage_4}
                      </span>
                    </h3>
                    <Elements stripe={stripePromise}>
                      <StripeBtn />
                    </Elements>
                  </div>
                </TabPanel>
                <TabPanel>
                  <RedemptionPage />
                </TabPanel>
              </Tabs>
            ) : this.state.isActiveCodeExist ? (
              <Tabs forceRenderTabPanel defaultIndex={0}>
                <TabList>
                  <Tab>{localizationStrings.redemptionTitle}</Tab>
                  <Tab disabled hidden>
                    {localizationStrings.subscriptionTitle}
                  </Tab>
                </TabList>
                <TabPanel>
                  <RedemptionPage />
                </TabPanel>
                <TabPanel>
                  <div className="example">
                    <div id="egeeTouchPlans" style={planTitleStyle}>
                      {localizationStrings.subscriptionTitle2}
                    </div>
                    <Elements stripe={stripePromise}>
                      <StripeBtn />
                    </Elements>
                  </div>
                </TabPanel>
              </Tabs>
            ) : (
              <Tabs forceRenderTabPanel defaultIndex={0}>
                <TabList>
                  <Tab>{localizationStrings.subscriptionTitle}</Tab>
                  <Tab disabled hidden>
                    {localizationStrings.redemptionTitle}
                  </Tab>
                </TabList>
                <TabPanel>
                  <div className="example">
                    <div id="egeeTouchPlans" style={planTitleStyle}>
                      {localizationStrings.subscriptionTitle2}
                    </div>
                    <h3
                      style={{
                        display: this.state.existingAccount ? "none" : "",
                        textAlign: "center",
                        marginBottom: "30px",
                      }}
                    >
                      {localizationStrings.subMessage_1}
                      <span style={{ color: "#0e78db" }}>
                        {localizationStrings.subMessage_2}
                      </span>
                      {localizationStrings.subMessage_3}
                      <span style={{ fontSize: "20px" }}>
                        {localizationStrings.subMessage_4}
                      </span>
                    </h3>
                    <Elements stripe={stripePromise}>
                      <StripeBtn />
                    </Elements>
                  </div>
                </TabPanel>
                <TabPanel>
                  <RedemptionPage />
                </TabPanel>
              </Tabs>
            )
          ) : (
            <Tabs forceRenderTabPanel defaultIndex={0}>
              <TabList>
                <Tab>{localizationStrings.subscriptionTitle}</Tab>
                <Tab>{localizationStrings.redemptionTitle}</Tab>
              </TabList>
              <TabPanel>
                <div className="example">
                  <div id="egeeTouchPlans" style={planTitleStyle}>
                    {localizationStrings.subscriptionTitle2}
                  </div>
                  <h3
                    style={{
                      display: this.state.existingAccount ? "none" : "",
                      textAlign: "center",
                      marginBottom: "30px",
                    }}
                  >
                    {localizationStrings.subMessage_1}
                    <span style={{ color: "#0e78db" }}>
                      {localizationStrings.subMessage_2}
                    </span>
                    {localizationStrings.subMessage_3}
                    <span style={{ fontSize: "20px" }}>
                      {localizationStrings.subMessage_4}
                    </span>
                  </h3>
                  <Elements stripe={stripePromise}>
                    <StripeBtn />
                  </Elements>
                </div>
              </TabPanel>
              <TabPanel>
                <RedemptionPage />
              </TabPanel>
            </Tabs>
          )}

          {/* //! Switch to the below Tabs if you had already implemented all the proration feature (For more information can be found on Internjsb@gmail.com Google Drive "Proration Table Doucment") */}
          {/* <Tabs forceRenderTabPanel defaultIndex={0}>
            <TabList>
              <Tab>{localizationStrings.redemptionTitle}</Tab>
              <Tab>{localizationStrings.subscriptionTitle}</Tab>
            </TabList>

            <TabPanel>
              <Redemption />
            </TabPanel>
            <TabPanel>
              <StripeProvider apiKey={apiKey}>
                <div className="example">
                  <div id="egeeTouchPlans" style={planTitleStyle}>
                    eGeeTouch {localizationStrings.subscriptionTitle}
                  </div>
                  <Elements>
                    <StripeBtn />
                  </Elements>
                </div>
              </StripeProvider>
            </TabPanel>
          </Tabs> */}
          {/* <Chatbot/> */}
        </div>
        // <StripeProvider apiKey="pk_test_B7HknqaFUiHiDRGUJE2l9jNB00pB8rQbU2">
      );
    } else {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <div>
            <Loading />
          </div>
        </div>
      );
    }
  }
}
